import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import DesignSystem from "../design-system/vue.js";
import { createPinia } from "pinia";
import { markAuthReady } from "./authState";
import "./registerServiceWorker";

// Mount immediately rather than from inside the auth callback. Public routes —
// above all the shared card page at /:cardID — must paint without waiting on
// Firebase. Protected routes await auth in the router guard instead.
const app = createApp(App);
DesignSystem.register(app);
app.use(createPinia()).use(store).use(router).mount("#app");

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/firebase.User
    store.state.main.user.displayName = user.displayName;
    store.state.main.user.email = user.email;
    store.state.main.user.photoURL = user.photoURL;
    store.commit("loadCurrentUserData");
  } else {
    store.commit("resetUser");
  }
  // Release any protected navigation waiting on a settled auth state.
  markAuthReady(user);
});
